"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./TagField.css");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Our main class component
var TagField = /*#__PURE__*/function (_Component) {
  _inherits(TagField, _Component);

  var _super = _createSuper(TagField);

  function TagField(props) {
    var _this;

    _classCallCheck(this, TagField);

    _this = _super.call(this, props);
    _this.state = {
      value: ''
    };
    _this.clickHandler = _this.clickHandler.bind(_assertThisInitialized(_this));
    _this.keyDownHandler = _this.keyDownHandler.bind(_assertThisInitialized(_this));
    _this.setWrapperRef = _this.setWrapperRef.bind(_assertThisInitialized(_this));
    _this.setDropdownRef = _this.setDropdownRef.bind(_assertThisInitialized(_this));
    return _this;
  } // Add and remove event listeners when component (un)mounts    


  _createClass(TagField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        dropdown: this.props.tags.length > 0 ? true : false
      });
      document.addEventListener('mousedown', this.clickHandler);
      document.addEventListener('ontouchstart', this.clickHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.clickHandler);
      document.removeEventListener('ontouchstart', this.clickHandler);
    } // The click handler to check if the user
    // has clicked inside or outside the tag field

  }, {
    key: "clickHandler",
    value: function clickHandler(event) {
      this.setState({
        dropdown: this.props.tags.length > 0 ? true : this.wrapperRef.contains(event.target)
      });
    } // Handler to detect when user hits enter   

  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(e) {
      var _this$props = this.props,
          clickEnterResult = _this$props.clickEnterResult,
          results = _this$props.results; // If ENTER

      if (e.keyCode === 13) {
        clickEnterResult(results && results.length > 0 ? results[0] : this.state.value);
        this.setState({
          value: ''
        });
      }
    } // When tags or dropdown updates, we update the tag field height

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.tags.length !== this.props.tags.length || prevState.dropdown !== this.state.dropdown) {
        this.setState({
          element_height: this.dropdownRef ? this.dropdownRef.clientHeight : 35
        });
      }
    } // Removes one or deletes all tags

  }, {
    key: "tagHandler",
    value: function tagHandler(action, index) {
      var _this$props2 = this.props,
          tags = _this$props2.tags,
          updated_tags = _this$props2.updated_tags;

      var array_copy = _toConsumableArray(tags);

      if (action === 'remove') {
        array_copy.splice(index, 1);
      } else if (action === 'delete') {
        array_copy.splice(array_copy);
        this.setState({
          dropdown: false
        });
      }

      updated_tags(array_copy);
    } // Capture ref data

  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: "setDropdownRef",
    value: function setDropdownRef(node) {
      this.dropdownRef = node;
    } // Render

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          clickEnterResult = _this$props3.clickEnterResult,
          deleteAll = _this$props3.deleteAll,
          disabled = _this$props3.disabled,
          _onChange = _this$props3.onChange,
          _this$props3$placehol = _this$props3.placeholder,
          placeholder = _this$props3$placehol === void 0 ? 'Input placeholder' : _this$props3$placehol,
          results = _this$props3.results,
          tags = _this$props3.tags,
          updated_tags = _this$props3.updated_tags,
          label = _this$props3.label,
          _this$state = this.state,
          element_height = _this$state.element_height,
          dropdown = _this$state.dropdown,
          value = _this$state.value;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "inputFieldWrapper tagFieldWrapper ".concat(disabled ? 'disabled' : ''),
        style: element_height && {
          height: element_height
        },
        ref: this.setWrapperRef
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        className: "search",
        name: "Search"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        "aria-label": label,
        className: "inputField input_icon temp_2",
        disabled: disabled,
        onChange: function onChange(e) {
          _this2.setState({
            value: e.target.value
          });

          _onChange && _onChange(e);
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.keyDownHandler(e);
        },
        placeholder: placeholder,
        type: "text",
        value: value
      }), updated_tags && deleteAll && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        className: "delete",
        name: "Bin",
        onClick: function onClick() {
          return _this2.tagHandler('delete');
        }
      }), dropdown && /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdownWrapper",
        ref: this.setDropdownRef
      }, value && results && /*#__PURE__*/_react["default"].createElement("div", {
        className: "results"
      }, results.map(function (tag, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "result",
          key: index,
          onClick: function onClick() {
            _this2.setState({
              value: ''
            });

            clickEnterResult && clickEnterResult(tag);
          }
        }, Object.entries(tag).map(function (_ref, index) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              val = _ref2[1];

          return key !== 'id' && key === 'name' || key === 'title' || key === 'text' && /*#__PURE__*/_react["default"].createElement("span", {
            key: index
          }, typeof val === 'string' ? val.replace(/_/g, ' ') : val);
        }));
      })), tags && /*#__PURE__*/_react["default"].createElement("div", {
        className: "tags"
      }, tags.map(function (tag, index) {
        return /*#__PURE__*/_react["default"].createElement(Tag, {
          key: index,
          onMouseDown: function onMouseDown() {
            return _this2.tagHandler('remove', index);
          },
          tag: tag
        });
      }))));
    }
  }]);

  return TagField;
}(_react.Component); // The component to render a tag


exports["default"] = TagField;

var Tag = function Tag(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag",
    onMouseDown: function onMouseDown() {
      return props.onMouseDown();
    }
  }, _typeof(props.tag) === 'object' ? Object.entries(props.tag).map(function (_ref3, index) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        val = _ref4[1];

    return key !== 'id' && /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, typeof val === 'string' ? val.replace(/_/g, ' ') : val);
  }) : /*#__PURE__*/_react["default"].createElement("span", null, props.tag), /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Close"
  }));
};